import { render } from "./AccidentCheck.vue?vue&type=template&id=17201084&scoped=true&ts=true"
import script from "./AccidentCheck.vue?vue&type=script&lang=ts"
export * from "./AccidentCheck.vue?vue&type=script&lang=ts"

import "./AccidentCheck.vue?vue&type=style&index=0&id=17201084&scoped=true&lang=less"

import exportComponent from "/workspace/source-code/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17201084"]])

export default __exports__